export default __webpack_public_path__ + "static/media/catalog-cover.32c997d5.svg";